<template>
  <div
    class="table-cell table-cell-category"
    :class="classes"
    data-bs-toggle="tooltip"
    :data-bs-placement="'top'"
    :title="!hasValue ? $t('groupsComparison.noResults') : null"
    @click="canClickTag ? onCellClick('categories', name) : null"
  >
    {{ formattedValue }}
  </div>
</template>

<script>
export default {
  name: 'PulsTableCategoryCell',
  props: {
    group: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    result: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: null
    },
    onCellClick: {
      type: Function,
      default: () => {}
    }
  },
  // cursor-pointer
  computed: {
    hasValue() {
      return this.value !== null && this.value !== undefined
    },
    canClickTag() {
      return this.hasValue
    },
    classes() {
      let baseClasses = `${this.name} ${this.canClickTag ? 'cursor-pointer' : ''}`
      if (!this.hasValue) {
        baseClasses += ' no-value'
      }
      return `${baseClasses} ${this.result}`
    },
    formattedValue() {
      return this.$localeNumber(this.value, 1)
    }
  }
}
</script>
